import { STRUCTURE_GRID_SIZE } from 'data/constants';
import { PositionType } from 'data/types';

export type FootprintScalingTransform = {
  ratio: number;
  dx: number;
  dy: number;
  center: PositionType;
};

export type FootprintGridBounds = {
  minX: number;
  minY: number;
  maxX: number;
  maxY: number;
  centerX: number;
  centerY: number;
};

export type ScaleCorner = 'nw' | 'ne' | 'sw' | 'se';

export type FootprintScalingDragMode = 'none' | 'translate' | 'scale';

export const SCALE_CORNERS: ScaleCorner[] = ['nw', 'ne', 'sw', 'se'];

export const FOOTPRINT_SCALING_CANVAS_OFFSET = 10000;

export function gridPointToCanvasPixel(point: { x: number; y: number }): {
  x: number;
  y: number;
} {
  return {
    x: point.x * STRUCTURE_GRID_SIZE + FOOTPRINT_SCALING_CANVAS_OFFSET,
    y: point.y * STRUCTURE_GRID_SIZE + FOOTPRINT_SCALING_CANVAS_OFFSET
  };
}

export function computeFootprintGridBounds(
  points: PositionType[]
): FootprintGridBounds | null {
  if (points.length < 3) return null;

  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;

  for (const p of points) {
    if (p.x < minX) minX = p.x;
    if (p.y < minY) minY = p.y;
    if (p.x > maxX) maxX = p.x;
    if (p.y > maxY) maxY = p.y;
  }

  return {
    minX,
    minY,
    maxX,
    maxY,
    centerX: (minX + maxX) / 2,
    centerY: (minY + maxY) / 2
  };
}

export function getCornerCursor(corner: ScaleCorner): string {
  if (corner === 'nw' || corner === 'se') return 'nwse-resize';
  return 'nesw-resize';
}

export function computeScaleRatio(
  initialDistance: number,
  currentDistance: number
): number {
  if (initialDistance <= 0) return 1;
  return currentDistance / initialDistance;
}

export function distanceFromCenter(
  point: PositionType,
  center: PositionType
): number {
  return Math.hypot(point.x - center.x, point.y - center.y);
}
